import { DateTime } from 'luxon';

export type ExecutionLogType = 'ERROR' | 'WARN' | 'DEBUG' | 'INFO';

export class ExecutionLog {
	dateCreated: string = DateTime.utc().toString();
	log: string;
	type: ExecutionLogType = 'INFO';
	//Only applicable to Info and Debug level logs
	logToIntegration?: boolean;
	isHandled?: boolean;

	constructor(
		message: string,
		type: ExecutionLogType = 'INFO',
		isHandled?: boolean,
		logToIntegration?: boolean
	) {
		this.log = message;
		this.type = type;
		this.isHandled = isHandled;
		this.logToIntegration = logToIntegration;
	}
}
